import camelcaseKeys from 'camelcase-keys';
var transformLegacyProtectionResponse = function (response) {
    var data = camelcaseKeys(response, { deep: true });
    return data;
};
export default transformLegacyProtectionResponse;
